<span [matTooltip]="alert?.toolTip" [matTooltipDisabled]="!alert?.toolTip">
  <span class="alert-badge" [ngClass]="getCssClass()">
    <i [attr.class]="'fa-solid ' + getIcon() + ' alert-icon'"></i>
  </span>
</span>
